<div class="flex flex-shrink flex-row gap-2">
	<ng-content />
</div>
